import React from 'react';
import 'moment/locale/it';
import { UIModal, UIModalBody, UIModalHeader, UiModalInternal } from '../../utilities/Modal';
import { UIPageHeader } from '../../utilities/Headers';
import UITypography from '../../utilities/Typography';
import UITable, { UITableHeadCell } from '../../utilities/Table';
import { Box } from '@mui/material';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';

const ModalOfficeConnectedAdmin = ({ modalOpen, handleModalClose, office }) => {
  const { onListDoctorsAdminPaginated } = useAccounts();

  const handleInternalClose = () => {
    handleModalClose();
  };

  const prepareValues = (doctors) =>
    doctors?.map((doctor) => {
      return {
        doctor: doctor,
        NameEl: (
          <Box>
            {doctor?.name} {doctor?.surname} - {doctor?.email}
          </Box>
        )
      };
    });

  const columns = [
    {
      name: <UITableHeadCell title={'Nome'} />,
      value: 'NameEl',
      size: 80
    }
  ];

  return (
    <UIModal open={modalOpen} onClose={handleInternalClose} allowFullScreen={true}>
      <UiModalInternal
        onClose={handleInternalClose}
        isLoading={false}
        containerSx={{
          bgcolor: '#FFF'
        }}
      >
        <UIModalHeader>
          <UIPageHeader
            title={'Dottori collegati ' + office?.name}
            sx={{
              textAlign: 'center'
            }}
          />

          <UITypography
            variant={'Oxygen400'}
            title={'Lista dei dottori collegati alla clinica  ' + office?.name}
            sxCustom={{
              m: '0px 10px 5px 10px',
              textAlign: 'center'
            }}
          />
        </UIModalHeader>
        <UIModalBody>
          <UITable
            columns={columns}
            prepareValues={prepareValues}
            enableSearch={false}
            infiniteScrollEndMessage={'Non ci sono altri dottori da mostrare'}
            infiniteScrollFunction={onListDoctorsAdminPaginated}
            enableCustomFilters={true}
            filtersData={{
              office_id: office?.id
            }}
            tableHeight={'calc(100vh - 450px)'}
            muiTableBodyRowProps={(data) => {
              return {
                sx: {
                  bgcolor: data?.row?.original?.date ? '#FDF2B5' : '',
                  p: 0,
                  '& td': data?.row?.original?.date
                    ? {
                        p: '5px 20px'
                      }
                    : {}
                }
              };
            }}
          />
        </UIModalBody>
      </UiModalInternal>
    </UIModal>
  );
};
export default ModalOfficeConnectedAdmin;
